import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import InstanceIndex from "../../components/UI/AddingData/InstanceIndex";
import TextInput from "../../components/UI/AddingData/TextInput";
import { handleLoading } from "../../store/actions/loadingAction";
import { createOrder } from "../../store/actions/ordersAction";
import { convertCurrency } from "../../store/actions/dollarPricesAction";
import ArrayIndex from "../../components/UI/AddingData/ArrayIndex";
import useSWR from "swr";
import CommonInputsContainer from "../../components/UI/TableView/CommonInputsContainer";
import { t } from "i18next";
import { fetcher } from "../../components/UI/TableView/ShowPaginationData";

const smalltalk = require("smalltalk");

//!0 cafe 1 for balance
const ORDER_TYPE = [{ id: 6, label: 'cafeCard' },]
function AddOrderScreen() {
  const [currentOrder, setCurrentOrder] = useState(
    { type: 6, name: 'Cafeteria Card' }
  );

  const _id = useParams().id;
  const { data, isLoading, error } = useSWR('/orders/' + _id, fetcher)

  const currentCenterId = JSON.parse(localStorage.getItem("centerId")).centerId;
  const history = useHistory();

  const onChangeValue = (type, value) => {
    let obj = currentOrder;

    if (type === 0) {
      obj.name = value;
    }
    else if (type === 1) {
      obj.iqd = Number(value);
    }
    else if (type === 2) {
      obj.type = Number(value);
      obj.name = ORDER_TYPE.find((ord) => ord.id === Number(value)).label
    }

    setCurrentOrder({ ...obj });
  };
  // console.log({currentOrder})
  const onSubmit = async () => {
    try {
      handleLoading();
      await checkValidation();
      let obj = {
        ...currentOrder,
        date: currentOrder.date || dayjs().valueOf(),
        centerId: currentCenterId,
        price: convertCurrency(currentOrder.iqd, 'USD'),
        paymentDetails: {
          payedType: 1,
          amountByCustomer: currentOrder.iqd,
          changeType: 1,
          changePrice: 0
        }
      };
      await createOrder(obj);
      history.goBack();

      handleLoading();
    } catch (e) {
      console.log(e);
      handleLoading();
      smalltalk.alert("Error", JSON.stringify(e));
    }
  };

  const setUp = () => {
    let objData = {};

    if (_id != 0) {
      objData = data[0];
    } else
      objData = {
        name: "Cafeteria Card",
        iqd: null,
        type: 6
      };

    setCurrentOrder(objData);
  };
  // console.log(currentOrder)
  const checkValidation = async () => {
    if (!currentOrder.name) {
      throw "Invlaid Name";
    }
    if (!currentOrder.iqd) {
      throw "Invlaid Price";
    }
    if (currentOrder.type === null) {
      throw "Invlaid Type";
    }
  };

  useEffect(() => {
    setUp();
  }, [data]);

  return (
    <div className='flex flex-col items-center justify-center flex-1 bg-[#f9f9f9] w-full '>
      {/* {requestModal && <RequestModal data={currentOrder} requestType={4} toggleModal={sendRequest} />} */}

      <CommonInputsContainer
        onSave={currentOrder?._id ? null : onSubmit}
        title={t('order')} >
        <InstanceIndex label={t("id")} value={`#${currentOrder && currentOrder._id ? currentOrder._id : ''}`} />
        <ArrayIndex
          valType={1}
          value={currentOrder.type}
          data={ORDER_TYPE}
          index="id"
          onChangeValue={()=>{}}
          label={t("revenueType")}
          type={2}
        />
        <TextInput
          label={t("price") + ' (دینار) '}
          placeHolder={t("price")}
          value={currentOrder.iqd}
          onChangeValue={onChangeValue}
          type={1}
          isNumber
        />
      </CommonInputsContainer>
    </div>
  );
}


const Container = ({ onChangeValue, currentOrder }) => {
  return (
    <div className='w-4/5 mt-10 border'>
      <InputContainer
        onChangeValue={onChangeValue}
        currentOrder={currentOrder}
      />
    </div>
  );
};

const InputContainer = ({ onChangeValue, currentOrder }) => {
  const { t } = useTranslation();

  return (
    <div className='items-center justify-center bg-white'>
      {/* <TextInput
        label={t("name")}
        placeHolder={t("name")}
        value={currentOrder.name}
        onChangeValue={onChangeValue}
        type={0}
      /> */}
      <InstanceIndex
        label={t("date")}
        value={dayjs(currentOrder.date).format("DD/MM/YYYY")}
      />
      <ArrayIndex
        valType={1}
        value={currentOrder.type}
        data={ORDER_TYPE}
        index="id"
        onChangeValue={onChangeValue}
        label={t("revenueType")}
        type={2}
      />
      <TextInput
        label={t("price") + ' (دینار) '}
        placeHolder={t("price")}
        value={currentOrder.iqd}
        onChangeValue={onChangeValue}
        type={1}
        isNumber
      />

      <div className='h-14' />
    </div>
  );
};

export default AddOrderScreen;
